import videojs from 'video.js';
import './button.js';
import './menu.js';

const Plugin = videojs.getPlugin('plugin');
const Component = videojs.getComponent('Component');

// Default options for the plugin.
const defaults = {};



/**
 * An advanced Video.js plugin. For more information on the API
 *
 * See: https://blog.videojs.com/feature-spotlight-advanced-plugins/
 */
class Settings extends Plugin {

  /**
   * Create a Settings plugin instance.
   *
   * @param  {Player} player
   *         A Video.js Player instance.
   *
   * @param  {Object} [options]
   *         An optional options object.
   *
   *         While not a core part of the Video.js plugin architecture, a
   *         second argument of options is a convenient way to accept inputs
   *         from your plugin's caller.
   */
  constructor(player, options) {
    // the parent class will add player under this.player
    super(player);

    this.options = videojs.mergeOptions(defaults, options);

    this.player.ready(() => {
      this.player.addClass('vjs-settings');
      setTimeout(() => this.buildUI(options), 50);
    });

    this.player.on('play', () => {
      const settingsMenuButton = this.player.getChild('controlBar').getChild('settingsMenuButton');
      if (this.player.getChild('settingsMenu').checkContent()) {
        settingsMenuButton.isDisableClick = false;
        settingsMenuButton.enable();
      } else {
        settingsMenuButton.isDisableClick = true;
        settingsMenuButton.disable();
	    }
    });
  }

  buildUI(options) {
    for (const componentName of Object.keys(this.options.items)) {
      const component = this.player.getChild('controlBar').getChild(componentName);
      if (component) {
        component.addClass('vjs-settings-menu-item-hide');
      }
    }
    this.player.addChild('settingsMenu', options);
    this.player.getChild('controlBar').addChild('settingsMenuButton');
    if (this.player.getChild('controlBar').getChild('fullscreenToggle')) {
      this.player.getChild('controlBar').el().insertBefore(
        this.player.getChild('controlBar').getChild('settingsMenuButton').el(),
        this.player.getChild('controlBar').getChild('fullscreenToggle').el()
      );
    }
  }
}

// Define default values for the plugin's `state` object here.
Settings.defaultState = {};

// Register the plugin with video.js.
videojs.registerPlugin('settings', Settings);

export default Settings;
